module.exports = __webpack_public_path__ + "img/hr-rock-huge-15.490e0802.png";